export default "__VITE_ASSET__e5I2jNdU__";